import React from 'react';
import { Button } from "@blueprintjs/core";

class SearchLinhVucVanBan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tenLinhVuc: this.props.parents.state.tenLinhVuc
    }
  }

  handleSearch(e) {
    e.preventDefault();
    this.props.parents.handleSearch();
  }

  handleChange(e) {
    this.setState({
      tenLinhVuc: e.target.value
    })
    let data = {
      target: {
        name: 'tenLinhVuc',
        value: e.target.value
      }
    }
    this.props.parents.handleChange(data)
  }

  render() {
    return (
      <section className="wrap-block search-container">
        <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
          <input
            type="text"
            name="tenLinhVuc"
            placeholder="Nhập"
            className="search-input"
            value={this.state.tenLinhVuc}
            onChange={this.handleChange.bind(this)}
          />
          <Button
            type="submit"
            text="Tìm kiếm"
            className={this.props.parents.state.tableLoading ? (this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"}
          />
        </form>
      </section>
    );
  }
}

export default SearchLinhVucVanBan;



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-van-ban/SearchLinhVucVanBan.jsx